import { render, staticRenderFns } from "./ChatMessageTextarea.vue?vue&type=template&id=0f1dd0a7&scoped=true"
import script from "./ChatMessageTextarea.vue?vue&type=script&lang=js"
export * from "./ChatMessageTextarea.vue?vue&type=script&lang=js"
import style0 from "./ChatMessageTextarea.vue?vue&type=style&index=0&id=0f1dd0a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1dd0a7",
  null
  
)

export default component.exports